import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Qué incluye el Pack 100 Citas?',
    a: 'El Pack Básico incluye 4 libros digitales con más de 400 citas y actividades, más 7 bonos exclusivos. El Pack Completo incluye 6 libros con más de 600 citas, cubriendo todas las relaciones familiares: Mamá e Hija, Mamá e Hijo, Papá e Hija, Papá e Hijo, Pareja y Familia.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el enlace de descarga de todos los PDFs. En menos de 5 minutos tenés todo el material en tu dispositivo. No hay envío físico — es 100% digital.'
  }, {
    q: '¿Para qué edad sirve?',
    a: 'Las citas están diseñadas para familias con hijos de todas las edades. Hay actividades adaptables para niños pequeños, adolescentes y también para la pareja. Funciona para cualquier tipo de familia.'
  }, {
    q: '¿Qué lo diferencia de lo que hay gratis en internet?',
    a: 'El Pack 100 Citas es un sistema completo y organizado con más de 500 ideas listas para usar. No tenés que buscar, planificar ni improvisar. Solo elegís una cita y disfrutás. Además incluye juegos secretos, frases con propósito y bonos exclusivos que no encontrás en ningún otro lado.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios, sin drama. Punto.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-57">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-800 border border-navy-700 rounded-2xl overflow-hidden transition-colors hover:border-navy-600" data-id="element-59">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-60">
                <span className="font-semibold text-lg text-white pr-8" data-id="element-61">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-blue-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" />
              </button>

              <AnimatePresence data-id="element-63">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-64">
                    <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-navy-700/50 pt-4 mt-2" data-id="element-65">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}